"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PromptDialogContext = exports.PromptContext = void 0;
const react_1 = require("react");
exports.PromptContext = react_1.createContext(undefined);
exports.PromptDialogContext = react_1.createContext(undefined);
//# sourceMappingURL=prompt-context.js.map